<template>
  <div id="messenger-container" class="messenger-info-page" v-if="!isLoading">
    <c-messanger-banner />
    <c-info-content />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import cMessangerBanner from '../../components/messanger/MessangerBanner.vue'
import cInfoContent from '../../components/messanger/InfoContent.vue'

export default {
  name: 'Messanger',
  components: {
    cMessangerBanner,
    cInfoContent
  },
  mounted () {
    const hasVisitedBefore = localStorage.getItem('hasVisitedBefore')

    if (!hasVisitedBefore) {
      this.actionPreloader(true)

      localStorage.setItem('hasVisitedBefore', 'true')

      setTimeout(() => {
        this.actionPreloader(false)
      }, 2000)
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.preloader.isLoading
    })
  },
  methods: {
    ...mapActions(['actionPreloader'])
  }
}
</script>
<style lang="scss" scoped>
  #messenger-container{
    padding-top: 96px;
  }
</style>
